/**
 * Created by sandeep on 24/04/2018.
 */
import React, {Component} from 'react';
import cx from 'classnames';
import {
  defaultTo
} from 'ramda';
import FaClockO from 'react-icons/lib/fa/clock-o';
import FaCheckCircle from 'react-icons/lib/fa/check-circle';
import FaBolt from 'react-icons/lib/fa/bolt';
import FaHourglass3 from 'react-icons/lib/fa/hourglass-o';
import PrimaryRedirectIcon from 'react-icons/lib/fa/external-link';
import SecondaryRedirectIcon from 'react-icons/lib/fa/external-link-square';
import moment from 'moment';
import * as sources from '../../constants/sources';
import goldStar from '../goldStar.svg';
import silverStar from '../silverStar.svg';
import spinner from '../Spinner.svg';
import './MobileRow.css';

export const ACCEPTED = 1;
export const UNEXPECTED_ERROR = 5;
export const TIMEOUT = 6;

function count(response, field, code) {
  return Object.values(defaultTo({}, response)).map(r => r[field]).filter(r => r === code).length;
}

const defaultZero = defaultTo(0);

export default class MobileRow extends Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false
     };
  }

  handleExpandEvent = event => {
    const value = !this.state.expanded;
    this.setState({
      expanded: value
    });
  };

  render() {
    const components = [];

    const {
      responses,
      CUSTOMER_ID: customerId,
      LOAN_AMOUNT: loanAmount,
      LOAN_TERM: loanTerm,
      COUNT_PRIMARY_REDIRECTS: prCount,
      COUNT_SECONDARY_REDIRECTS: srCount,
      DATETIME_APP: startTime,
      RESPONSE_TIME: endTime,
      SOURCE: source,
      EMAIL_ADDRESS: email,
    } = this.props.row;

    let displayId = customerId;

    if (email) {
      displayId = `${customerId}:${email.substr(email.length - 4)}`;
    }


    const requestTime = moment(startTime).format('HH:mm:ss DD/MM');

    let totalTime;

    if (endTime) {
      totalTime = moment(endTime).diff(startTime);
    }


    const acceptCount = count(responses, 'RESULT_CODE', ACCEPTED);
    const errorCount = count(responses, 'RESULT_CODE', UNEXPECTED_ERROR);
    const timeoutCount = count(responses, 'RESULT_CODE', TIMEOUT);

    const rowClasses = cx({
      'row': true,
      'ok': acceptCount > 0,
      'noAccepts': acceptCount === 0,
      'warn': timeoutCount > 0,
      'error': errorCount > 0,
      'inProgress': !endTime,
    });


    const meta = (
      <div className="stats">
        <div className="stat">
          <div className="icon">
            <FaClockO/>
          </div>
          <div className="value responseDelay">
            {totalTime || ''}
          </div>
        </div>
        <div className="stat">
          <div className="icon">
            <FaCheckCircle/>
          </div>

          <div className="value">
            {acceptCount}
          </div>
        </div>
        <div className="stat">
          <div className="icon">
            <PrimaryRedirectIcon/>
          </div>
          <div className="value">
            {defaultZero(prCount)}
          </div>
        </div>
        <div className="stat">
          <div className="icon">
            <SecondaryRedirectIcon/>
          </div>
          <div className="value">
            {defaultZero(srCount)}
          </div>
        </div>
        <div className="stat">
          <div className="icon">
            <FaBolt/>
          </div>
          <div className="value">
            {errorCount}
          </div>
        </div>
        <div className="stat">
          <div className="icon">
            <FaHourglass3/>
          </div>
          <div className="value">
            {timeoutCount}
          </div>
        </div>
      </div>
    );

    if (this.state.expanded) {
      components.push(meta);
    }

    // let star = <div className="starPlaceholder"/>;
    let star = <img src={spinner} className="spinner" alt="loading"/>;


    if (srCount > 0) {
      star = <img src={silverStar} className="star" alt="secondary redirect"/>;
    }

    if (prCount > 0) {
      star = <img src={goldStar} className="star" alt="primary redirect"/>;
    }

    let sourceCode = '?';

    if (source === sources.ORGANIC) sourceCode = 'O';
    if (source === sources.NETWORK) sourceCode = 'N';
    if (source === sources.EMAIL) sourceCode = 'E';
    if (source === sources.PPC) sourceCode = 'A';
    if (source === sources.PAID_SOCIAL) sourceCode = 'S';
    if (source === sources.CC_3PI) sourceCode = 'T';

    return (
      <div className="row" onClick={this.handleExpandEvent}>
        <div className={rowClasses}>

          <div className="flex">
            <div className="source">{sourceCode}</div>
            <div className="requestTime">{requestTime}</div>
            <div className="starWrapper">{star}</div>
          </div>

          <div className="flex">
            <div className="name">{displayId}</div>
            <div className="loanAmount">£{loanAmount}</div>
            <div className="loanTerm">{loanTerm} months</div>
          </div>

          {components}

        </div>
      </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/RequestTable/Row/MobileRow.js